module.exports = __webpack_public_path__ + "static/media/2.d9f9d3ae.png";